import { imageUtils } from "@/business/shared/commons/imageUtils/imageUtils";

export interface NewsCreateRequest {
  title: string;
  body: string;
  image1: File;
}

export interface News {
  body: string;
  date: string;
  shortTitle: string;
  slider: string;
  title: string;
}

export interface NewsEditRequest {
  title: string;
  body: string;
  image1: File | null;
  shortTitle: string;
  isEdit: boolean;
}

export function NewsActions() {
  function createNewsRequest(
    title: string,
    body: string,
    image1: File
  ): NewsCreateRequest {
    return {
      title: title,
      body: body,
      image1: image1,
    };
  }

  function infoNews(
    body: string,
    date: string,
    shortTitle: string,
    slider: string,
    title: string
  ): News {
    return {
      body: body,
      date: date,
      shortTitle: shortTitle,
      slider: slider,
      title: title,
    };
  }

  function editNewsRequest(
    title: string,
    body: string,
    image1: File | null,
    shortTitle: string,
    isEdit: boolean
  ): NewsEditRequest {
    return {
      title: title,
      body: body,
      image1: image1,
      shortTitle: shortTitle,
      isEdit: isEdit,
    };
  }

  function deserialize(object: string): News[] {
    const parseResponse = JSON.parse(JSON.stringify(object));
    return parseResponse.news.map((news: News) => {
      return infoNews(
        news.body,
        news.date,
        news.shortTitle,
        imageUtils.putTimeStamp(news.slider),
        news.title
      );
    });
  }

  return {
    createNewsRequest,
    infoNews,
    editNewsRequest,
    deserialize,
  };
}
